import styles from "./switch.module.css";
interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id: string;
  className?: string;
}

export const Switch = ({ checked, onChange, id, className }: SwitchProps) => {
  return (
    <>
      <input type="checkbox" id={id} hidden={true} checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <label className={`${styles.switch} ${className || ""}`} htmlFor={id} />
    </>
  );
};
